import { ROLES } from '@AuthModule';

const { ADOPTER, ALL_ANIMALS_TABLE, DONOR, DRIVER, FOSTER, OWNER, PEOPLE, VOLUNTEER } = ROLES;

// NOTE :: Every list with saved reports turned on (its FiltersTemplate `savedReportsTableId`, also the api's
// SavedReportController::SAVED_REPORT_LISTS): the label the Shared Reports page shows and the route "View filter"
// opens, and the permissions its route needs, if any — any one of them is enough, like the route guard (the api's
// SavedReportController::LIST_PERMISSIONS mirrors it). A list added to the api must be added here too.
const SAVED_REPORT_LISTS: Record<string, { label: string; permissions?: ROLES[]; routeName: string }> = {
  'all-animals': { label: 'navigation.animals.all', permissions: [ALL_ANIMALS_TABLE], routeName: 'all-animals' },
  'animals-in-care': { label: 'navigation.animals.inCare', routeName: 'animals-in-care' },
  people: {
    label: 'navigation.people',
    permissions: [PEOPLE, ADOPTER, OWNER, FOSTER, DONOR, VOLUNTEER, DRIVER],
    routeName: 'people',
  },
};

// NOTE :: The query param "View filter" on the Shared Reports page adds to a list's route; the list reads it, applies
// that shared report as an unsaved view and drops the param.
const REPORT_TEMPLATE_QUERY = 'shared_report';

export { REPORT_TEMPLATE_QUERY, SAVED_REPORT_LISTS };
